const hexRegex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;

export const getRGBA = (hex: string, opacity: number) => {
  if (!hexRegex.test(hex) || opacity > 1 || opacity < 0) {
    console.trace(`invalid hex color <${hex}> or opacity <${opacity}>`);
    return 'inherit';
  }

  hex = hex.replace('#', '');
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  const r = Number.parseInt(hex.substring(0, 2), 16);
  const g = Number.parseInt(hex.substring(2, 4), 16);
  const b = Number.parseInt(hex.substring(4, 6), 16);

  const result = `rgba(${r},${g},${b},${opacity})`;
  return result;
};
